import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventType } from '../../constants';
import { EcommerceApplicationEventPayload } from '~shared/models';

export class GATrackingRemoveItemFromCartEvent implements GATrackingEvent {
  constructor(private RemoveItemFromCartApplicationEventPayload: EcommerceApplicationEventPayload) {}

  getEventType(): GATrackingEventType {
    return GATrackingEventType.RemoveItemFromCart;
  }

  getPayload(): any {
    return {
      event: this.getEventType(),
      gtmCustom: {
        ...this.RemoveItemFromCartApplicationEventPayload,
      },
    };
  }
}
